<template>
  <div
    id="content"
    class="income-statement">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.incomestatement') }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="select_date == '1'"
                    class="badge badge-secondary">{{ $t('message.today') }}</span>
                  <span
                    v-if="select_date == '2'"
                    class="badge badge-secondary">{{ $t('message.thismonth') }}</span>
                  <span
                    v-if="select_date == '3'"
                    class="badge badge-secondary">{{ $t('message.thisyear') }}</span>
                  <span
                    v-if="select_date == '4'"
                    class="badge badge-secondary">{{ $t('message.7daysago') }}</span>
                  <span
                    v-if="select_date == '5'"
                    class="badge badge-secondary">{{ $t('message.1monthago') }}</span>
                  <span
                    v-if="select_date == '6'"
                    class="badge badge-secondary">{{ $t('message.6monthsago') }}</span>
                  <span
                    v-if="select_date == '7'"
                    class="badge badge-secondary">{{ $t('message.1yearago') }}</span>
                  <span
                    v-if="select_date == '8'"
                    class="badge badge-secondary">{{ $t('message.custom') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.date') }}</label>
                    <select
                      ref="select-date"
                      v-model="select_date"
                      class="custom-select">
                      <option value="1">{{ $t('message.today') }}</option>
                      <option value="2">{{ $t('message.thismonth') }}</option>
                      <option value="3">{{ $t('message.thisyear') }}</option>
                      <option value="4">{{ $t('message.7daysago') }}</option>
                      <option value="5">{{ $t('message.1monthago') }}</option>
                      <option value="6">{{ $t('message.6monthsago') }}</option>
                      <option value="7">{{ $t('message.1yearago') }}</option>
                      <option value="8">{{ $t('message.custom') }}</option>
                    </select>
                  </div>
                  <div
                    v-if="select_date == '8'"
                    class="form-group mt-3 mb-0"
                    style="margin-bottom: 5px;">
                    <!-- <label>
                      {{ $t('message.custom') }}
                      <i class="fas fa-level-down-alt" style="font-size: 11px;"></i>
                    </label> -->
                    <BaseDateRange
                      v-model="date"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ getParam }}</pre> -->

      <template v-if="ready && income_statement !== null">
        <section class="mt-2">
          <div>
            <section-title
              :title="datePeriod(date.start, date.end)"
              fontweight="bold"/>
          </div>
        </section>

        <section class="mt-3">
          <div class="main row m-0">
            <div class="receive inner-main">
              <div class="thead">
                <div class="form-row">
                  <div class="col-6">
                    {{ $t('apps.reports.message.income') }}
                  </div>
                  <div class="col-6 text-right">
                    {{ $t('apps.reports.message.total') }}
                  </div>
                </div>
              </div>
              <div class="body">
                <div
                  :class="[{'active': this.state.show_sales}]"
                  class="list pointer"
                  @click="showSales()">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      <i
                        :class="[{
                          'fa-angle-right': !this.state.show_sales,
                          'fa-angle-down': this.state.show_sales
                        }]"
                        class="fas"/>
                      {{ $t('apps.reports.message.salesservices') }}
                    </div>
                    <div class="col-6 text-right">
                      <span :class="[{'text-underline-border': this.state.show_sales}]">{{ getNumber(receipts.sale.total) }}</span>
                    </div>
                  </div>
                  <div
                    v-if="this.state.show_sales"
                    class="details">
                    <div
                      class="list pointer"
                      @click="showSalePos()">
                      <div class="item form-row col-12 pl-1 pr-1 m-0">
                        <div class="col-6 pl-4">
                          <i
                            :class="[{
                              'fa-angle-right': !this.state.show_sale_pos,
                              'fa-angle-down': this.state.show_sale_pos
                            }]"
                            class="fas"/>
                          {{ $t('apps.reports.message.pos') }}
                        </div>
                        <div class="col-6 text-right">
                          <span :class="[{'text-underline-border': this.state.show_sale_pos}]">{{ getNumber(receipts.sale.pos.total) }}</span>
                        </div>
                      </div>
                      <template v-if="this.state.show_sale_pos">
                        <div
                          v-for="(data, index) in receipts.sale.pos.details"
                          :key="index"
                          class="detais">
                          <div class="list">
                            <div class="item form-row col-12 pl-1 pr-1 m-0">
                              <div class="col-6 pl-5">
                                {{ data.item }}
                              </div>
                              <div class="col-6 text-right">
                                {{ getNumber(data.total) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      class="list pointer"
                      @click="showSaleOther()">
                      <div class="item form-row col-12 pl-1 pr-1 m-0">
                        <div class="col-6 pl-4">
                          <i
                            :class="[{
                              'fa-angle-right': !this.state.show_sale_other,
                              'fa-angle-down': this.state.show_sale_other
                            }]"
                            class="fas"/>
                          {{ $t('apps.reports.message.saleother') }}
                        </div>
                        <div class="col-6 text-right">
                          <span :class="[{'text-underline-border': this.state.show_sale_other}]">{{ getNumber(receipts.sale.other.total) }}</span>
                        </div>
                      </div>
                      <template v-if="this.state.show_sale_other">
                        <div
                          v-for="(data, index) in receipts.sale.other.details"
                          :key="index"
                          class="detais">
                          <div class="list">
                            <div class="item form-row col-12 pl-1 pr-1 m-0">
                              <div class="col-6 pl-5">
                                {{ data.item }}
                              </div>
                              <div class="col-6 text-right">
                                {{ getNumber(data.total) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div
                  v-for="(tax, index) in receipts.taxes"
                  :key="index"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ getMasterDataTextWithRegex(tax.displayText, $t) }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(tax.total) }}</span>
                    </div>
                  </div>
                </div>
                <!-- <div
                  v-if="receipts.service_charge !== 0"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.outputservicecharge') }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(receipts.service_charge) }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="receipts.tax !== 0"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.outputtax') }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(receipts.tax) }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="receipts.fee !== 0"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.outputfee') }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(receipts.fee) }}</span>
                    </div>
                  </div>
                </div> -->
                <div class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.totalincome') }}
                    </div>
                    <div class="col-6 text-right">
                      <span class="text-underline-border">{{ getNumber(receipts.total) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payments inner-main">
              <div class="thead">
                <div class="form-row">
                  <div class="col-6">
                    {{ $t('apps.reports.message.operatingexpenses') }}
                  </div>
                  <div class="col-6 text-right">
                    {{ $t('apps.reports.message.total') }}
                  </div>
                </div>
              </div>
              <div class="body">
                <div
                  :class="[{'active': this.state.show_purchase}]"
                  class="list pointer"
                  @click="showPurchase()">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      <i
                        :class="[{
                          'fa-angle-right': !this.state.show_purchase,
                          'fa-angle-down': this.state.show_purchase
                        }]"
                        class="fas"/>
                      {{ $t('apps.reports.message.costofgoodssold') }}
                    </div>
                    <div class="col-6 text-right">
                      <span :class="[{'text-underline-border': this.state.show_purchase}]">{{ getNumber(payments.purchase.total) }}</span>
                    </div>
                  </div>
                  <template v-if="this.state.show_purchase">
                    <div
                      v-for="(data, index) in payments.purchase.details"
                      :key="index"
                      class="detais">
                      <div class="list">
                        <div class="item form-row col-12 pl-1 pr-1 m-0">
                          <div class="col-6 pl-4">
                            {{ data.item }}
                          </div>
                          <div class="col-6 text-right">
                            {{ getNumber(data.total) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  :class="[{'active': this.state.show_expenses}]"
                  class="list pointer"
                  @click="showExpenses()">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      <i
                        :class="[{
                          'fa-angle-right': !this.state.show_expenses,
                          'fa-angle-down': this.state.show_expenses
                        }]"
                        class="fas"/>
                      {{ $t('apps.reports.message.expenses') }}
                    </div>
                    <div class="col-6 text-right">
                      <span :class="[{'text-underline-border': this.state.show_expenses}]">{{ getNumber(payments.expense.total) }}</span>
                    </div>
                  </div>
                  <div
                    v-if="this.state.show_expenses"
                    class="details">
                    <div
                      class="list pointer"
                      @click="showExpenseCompany()">
                      <div class="item form-row col-12 pl-1 pr-1 m-0">
                        <div class="col-6 pl-4">
                          <i
                            :class="[{
                              'fa-angle-right': !this.state.show_expense_company,
                              'fa-angle-down': this.state.show_expense_company
                            }]"
                            class="fas"/>
                          {{ $t('apps.reports.message.payforcompany') }}
                        </div>
                        <div class="col-6 text-right">
                          <span :class="[{'text-underline-border': this.state.show_expense_company}]">{{ getNumber(payments.expense.company.total) }}</span>
                        </div>
                      </div>
                      <template v-if="this.state.show_expense_company">
                        <div
                          v-for="(data, index) in payments.expense.company.details"
                          :key="index"
                          class="detais">
                          <div class="list">
                            <div class="item form-row col-12 pl-1 pr-1 m-0">
                              <div class="col-6 pl-5">
                                {{ data.item }}
                              </div>
                              <div class="col-6 text-right">
                                {{ getNumber(data.total) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      class="list pointer"
                      @click="showExpensePerson()">
                      <div class="item form-row col-12 pl-1 pr-1 m-0">
                        <div class="col-6 pl-4">
                          <i
                            :class="[{
                              'fa-angle-right': !this.state.show_expense_person,
                              'fa-angle-down': this.state.show_expense_person
                            }]"
                            class="fas"/>
                          {{ $t('apps.reports.message.payforemployee') }}
                        </div>
                        <div class="col-6 text-right">
                          <span :class="[{'text-underline-border': this.state.show_expense_person}]">{{ getNumber(payments.expense.person.total) }}</span>
                        </div>
                      </div>
                      <template v-if="this.state.show_expense_person">
                        <div
                          v-for="(data, index) in payments.expense.person.details"
                          :key="index"
                          class="detais">
                          <div class="list">
                            <div class="item form-row col-12 pl-1 pr-1 m-0">
                              <div class="col-6 pl-5">
                                {{ data.item }}
                              </div>
                              <div class="col-6 text-right">
                                {{ getNumber(data.total) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div
                  :class="[{'active': this.state.show_payroll}]"
                  class="list pointer"
                  @click="showPayroll()">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      <i
                        :class="[{
                          'fa-angle-right': !this.state.show_payroll,
                          'fa-angle-down': this.state.show_payroll
                        }]"
                        class="fas"/>
                      {{ $t('apps.reports.message.costofpayslips') }}
                    </div>
                    <div class="col-6 text-right">
                      <span :class="[{'text-underline-border': this.state.show_payroll}]">{{ getNumber(payments.payroll.total) }}</span>
                    </div>
                  </div>
                  <template v-if="this.state.show_payroll">
                    <div
                      v-for="(data, index) in payments.payroll.details"
                      :key="index"
                      class="detais">
                      <div class="list">
                        <div class="item form-row col-12 pl-1 pr-1 m-0">
                          <div class="col-6 pl-4">
                            {{ data.item }}
                          </div>
                          <div class="col-6 text-right">
                            {{ getNumber(data.total) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-for="(tax, index) in payments.taxes"
                  :key="index"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ getMasterDataTextWithRegex(tax.displayText, $t) }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(tax.total) }}</span>
                    </div>
                  </div>
                </div>
                <!-- <div
                  v-if="payments.tax !== 0"
                  class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.inputtax') }}
                    </div>
                    <div class="col-6 text-right">
                      <span>{{ getNumber(payments.tax) }}</span>
                    </div>
                  </div>
                </div> -->
                <div class="list">
                  <div class="item form-row col-12 pl-1 pr-1 m-0">
                    <div class="col-6">
                      {{ $t('apps.reports.message.totaloperatingexpenses') }}
                    </div>
                    <div class="col-6 text-right">
                      <span class="text-underline-border">{{ getNumber(payments.total) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-3">
          <div class="row p-0 m-0">
            <div class="col-6 ml-auto p-0 pl-2">
              <p class="m-0"><strong>{{ $t('apps.reports.message.summaryresults') }}</strong></p>
              <div class="row p-0 m-0 mt-2">
                <div class="col-8 p-0">{{ $t('apps.reports.message.pretaxincome') }}</div>
                <div class="col-4 p-0 text-right">{{ getNumber(income_statement.totals.pretaxincome) }}</div>
              </div>
              <div class="row p-0 m-0 mt-2">
                <div class="col-8 p-0">{{ $t('apps.reports.message.netincome') }}</div>
                <div class="col-4 p-0 text-right">
                  <span class="text-underline-border">{{ getNumber(income_statement.totals.netincome) }}</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getMasterDataTextWithRegex } from '@/helpers'
import sidebarModule from './../../sidebarModule'

export default {
  name: 'ReportIncomeStatementAll',
  data () {
    return {
      getMasterDataTextWithRegex,
      ready: false,

      select_date: '2',

      date: {
        start: null,
        end: null,
      },

      state: {
        show_sales: false,
        show_sale_pos: false,
        show_sale_other: false,

        show_expenses: false,
        show_expense_company: false,
        show_expense_person: false,

        show_purchase: false,

        show_payroll: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      income_statement: 'getIncomeStatement',
      dateFormat: 'getDateFormat',
      lang: 'getLang',
    }),
    receipts () {
      if (this.income_statement) return this.income_statement.receipts
    },
    payments () {
      if (this.income_statement) return this.income_statement.payments
    },
    formats () {
      return {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: [this.dateFormat], // Only for `v-date-picker`
        dayPopover: this.dateFormat, // Only for `v-date-picker`
      }
    },
    getParam () {
      var param = '?'
      var obj = {}

      if (this.date.start && this.date.end) {
        var start_at = this.date.start
        var end_at = new Date(this.date.end.toISOString())
        obj['start_at'] = start_at.toISOString()
        obj['end_at'] = this.moment(end_at).endOf('day').toISOString()
      }

      for (let key in obj) {
        param += key + '=' + obj[key] + '&'
      }

      return param
    },
  },
  methods: {
    ...mapActions([

    ]),
    showSales () {
      this.hideExpenses()
      this.hidePurchase()
      this.hidePayroll()
      this.state.show_sales = !this.state.show_sales
    },
    showSalePos () {
      this.$nextTick(function () {
        this.showSales()
        this.state.show_sale_pos = !this.state.show_sale_pos
      })
    },
    showSaleOther () {
      this.$nextTick(function () {
        this.showSales()
        this.state.show_sale_other = !this.state.show_sale_other
      })
    },
    showExpenses () {
      this.hideSales()
      this.hidePurchase()
      this.hidePayroll()
      this.state.show_expenses = !this.state.show_expenses
    },
    showExpenseCompany () {
      this.$nextTick(function () {
        this.showExpenses()
        this.state.show_expense_company = !this.state.show_expense_company
      })
    },
    showExpensePerson () {
      this.$nextTick(function () {
        this.showExpenses()
        this.state.show_expense_person = !this.state.show_expense_person
      })
    },
    showPurchase () {
      this.hideSales()
      this.hideExpenses()
      this.hidePayroll()
      this.state.show_purchase = !this.state.show_purchase
    },
    showPayroll () {
      this.hideSales()
      this.hideExpenses()
      this.hidePurchase()
      this.state.show_payroll = !this.state.show_payroll
    },
    hideSales () {
      this.state.show_sales = false
    },
    hideExpenses () {
      this.state.show_expenses = false
    },
    hidePurchase () {
      this.state.show_purchase = false
    },
    hidePayroll () {
      this.state.show_payroll = false
    },
    async getIncomeStatement () {
      // use this for close dropdown
      this.closeDropdown()

      this.ready = false

      await this.$store.dispatch('getIncomeStatement', this.getParam)

      this.ready = true
    },
  },
  watch: {
    ready: function (after) {
      if (after == true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    'date': {
      handler: function (after) {
        this.getIncomeStatement()
      },
      deep: true,
    },
    select_date: function (after, before) {
      let val = after

      this.updateDropdownPosition()

      switch (val) {
        // this day
        case '1':
          this.date.start = this.moment().startOf('day').toDate()
          this.date.end = this.moment().endOf('day').toDate()
          break
        // this month
        case '2':
          this.date.start = this.moment().startOf('month').toDate()
          this.date.end = this.moment().endOf('month').toDate()
          break
        // this year
        case '3':
          this.date.start = this.moment().startOf('year').toDate()
          this.date.end = this.moment().endOf('year').toDate()
          break
        // 7 days ago
        case '4':
          var startOfThisDay = this.moment().startOf('day')
          this.date.start = this.moment(startOfThisDay).subtract(7, 'day').toDate()
          this.date.end = this.moment().endOf('day').toDate()
          break
        // 1 month ago
        case '5':
          var startOfThisDay = this.moment().startOf('day')
          this.date.start = this.moment(startOfThisDay).subtract(1, 'month').toDate()
          this.date.end = this.moment().endOf('day').toDate()
          break
        // 6 months ago
        case '6':
          var startOfThisDay = this.moment().startOf('day')
          this.date.start = this.moment(startOfThisDay).subtract(6, 'month').toDate()
          this.date.end = this.moment().endOf('day').toDate()
          break
        // 1 year ago
        case '7':
          var startOfThisDay = this.moment().startOf('day')
          this.date.start = this.moment(startOfThisDay).subtract(1, 'year').toDate()
          this.date.end = this.moment().endOf('day').toDate()
          break
        // custom
        case '8':
          this.$refs['select-date'].blur()
          break
      }
    },
  },
  created: function () {
    // set default date
    this.date.start = this.moment().startOf('month').toDate()
    this.date.end = this.moment().endOf('month').toDate()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.reports.title'),
      current: {
        app_name: 'reports',
        app_id: 8,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearSales'])
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
.main {
  border: 1px solid #dee2e6;
  background: #fff;
}
.main .inner-main {
  width: 50%;
}
.main .inner-main.receive {
  border-right: solid 1px var(--border-color);
}
.main .inner-main .thead {
  padding: 10px 10px 9px 10px;
  border-bottom: solid 2px var(--border-color);
  font-weight: bold;
}
.main .inner-main .body .list {
  box-shadow: 0px 1px 0px 0px var(--border-color);
}
.main .inner-main .body .list .item {
  box-shadow: 0px 1px 0px 0px var(--border-color);
}
.main .inner-main .body .list.active {
  background: rgba(216,226,231,.25);
}
.main .inner-main .body .list .item {
  padding: 8px 10px 7px 10px;
}
.pointer {
  cursor: pointer;
}
.c-pane-container, .c-pane-container .c-pane {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/report/income-statement/All.vue